export const resetAthlete = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_ATHLETE" });
  };
};

export const resetAthleteRequest = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_ATHLETE_REQUEST" });
  };
};

export const resetJoinCsaRequest = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_JOIN_CSA_REQUEST" });
  };
};

export const resetContactCsa = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_CONTACT_REQUEST" });
  };
};

export const requestJoinCsa = (requestInfo) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    const timeStamp = new Date();

    var infoRequest = {
      parentFirstName: requestInfo.parentFirstName,
      parentLastName: requestInfo.parentLastName,
      parentEmail: requestInfo.parentEmail,
      parentPhoneNumber: requestInfo.parentPhoneNumber,
      athleteFirstName: requestInfo.athleteFirstName,
      athleteLastName: requestInfo.athleteLastName,
      athleteGradYear: requestInfo.athleteGradYear,
      athleteSport: requestInfo.athleteSport,
      athleteState: requestInfo.athleteState,
      formComments: requestInfo.formComments,
      dateTime: timeStamp,
    };

    const batch = firestore.batch();

    const addRequest = firestore.collection("joinCsaRequests").doc();
    batch.set(addRequest, infoRequest, { merge: true });

    batch
      .commit()
      .then(() => {
        dispatch({ type: "JOIN_CSA_REQUEST_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "JOIN_CSA_REQUEST_ERROR", error });
      });
  };
};

export const contactCsa = (requestInfo) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    const timeStamp = new Date();

    var infoRequest = {
      contactEmail: requestInfo.contactEmail,
      contactName: requestInfo.contactName,
      formComments: requestInfo.formComments,
      dateTime: timeStamp,
    };

    const batch = firestore.batch();

    const addRequest = firestore.collection("contactCsaRequests").doc();
    batch.set(addRequest, infoRequest, { merge: true });

    batch
      .commit()
      .then(() => {
        dispatch({ type: "CONTACT_REQUEST_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "CONTACT_REQUEST_ERROR", error });
      });
  };
};

export const requestAthleteInfo = (requestInfo) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    const timeStamp = new Date();
    var infoRequest = {
      coachEmail: requestInfo.coachEmail,
      coachPhone: requestInfo.coachPhone,
      coachFirstName: requestInfo.coachFirstName,
      coachLastName: requestInfo.coachLastName,
      collegeName: requestInfo.collegeName,
      collegeWebsite: requestInfo.collegeWebsite,
      formComments: requestInfo.formComments,
      athleteName: requestInfo.athleteName,
      athleteUrl: requestInfo.athleteUrl,
      dateTime: timeStamp,
    };

    const batch = firestore.batch();

    const addRequest = firestore.collection("athleteInfoRequests").doc();
    batch.set(addRequest, infoRequest, { merge: true });

    batch
      .commit()
      .then(() => {
        dispatch({ type: "INFO_REQUEST_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "INFO_REQUEST_ERROR", error });
      });
  };
};

export const deleteAthlete = (athleteId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    const currentTime = firebase.firestore.Timestamp.fromDate(new Date());

    // get customUrl
    var urlRef = firestore.collection("users").doc(athleteId);
    urlRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          const athleteUrl = doc.data().customUrl;

          const batch = firestore.batch();

          const athleteRef = firestore.collection("athletes").doc(athleteUrl);
          batch.update(athleteRef, { profilePublic: false });

          const athleteAdminRef = firestore
            .collection("adminAthletes")
            .doc(athleteId);
          batch.update(athleteAdminRef, { profilePublic: false });

          const archiveRef = firestore
            .collection("athleteArchive")
            .doc(athleteId);
          batch.set(archiveRef, { archiveDate: currentTime }, { merge: true });

          const newRequestRef = firestore
            .collection("testNewRequests")
            .doc(athleteId);

          newRequestRef.get().then((doc) => {
            if (doc.exists) {
              const batch = firestore.batch();
              batch.set(newRequestRef, { status: false }, { merge: true });
              batch.commit();
            }
          });

          const role = { role: "newUser", createdAt: currentTime };
          const roleRef = firestore.collection("userRole").doc(athleteId);

          roleRef.get().then((doc) => {
            if (doc.exists) {
              const batch = firestore.batch();
              batch.set(
                roleRef,
                { ...role, userUID: athleteId },
                { merge: true }
              );
              batch.commit();
            }
          });

          batch
            .commit()
            .then(() => {
              dispatch({ type: "DELETE_ATHLETE_SUCCESS" });
            })
            .catch((error) => {
              dispatch({ type: "DELETE_ATHLETE_ERROR", error });
            });
        } else {
          const urlRef = firestore.collection("testUsers").doc(athleteId);
          urlRef.get().then((doc) => {
            if (doc.exists) {
              const athleteUrl = doc.data().customUrl;

              const batch = firestore.batch();

              const athleteRef = firestore
                .collection("athletes")
                .doc(athleteUrl);
              batch.update(athleteRef, { profilePublic: false });

              const athleteAdminRef = firestore
                .collection("adminAthletes")
                .doc(athleteId);
              batch.update(athleteAdminRef, { profilePublic: false });

              const archiveRef = firestore
                .collection("athleteArchive")
                .doc(athleteId);
              batch.set(
                archiveRef,
                { archiveDate: currentTime },
                { merge: true }
              );

              const newRequestRef = firestore
                .collection("testNewRequests")
                .doc(athleteId);

              newRequestRef.get().then((doc) => {
                if (doc.exists) {
                  const batch = firestore.batch();
                  batch.set(newRequestRef, { status: false }, { merge: true });
                  batch.commit();
                }
              });

              const role = { role: "newUser", createdAt: currentTime };
              const roleRef = firestore.collection("userRole").doc(athleteId);

              roleRef.get().then((doc) => {
                if (doc.exists) {
                  const batch = firestore.batch();
                  batch.set(
                    roleRef,
                    { ...role, userUID: athleteId },
                    { merge: true }
                  );
                  batch.commit();
                }
              });

              batch
                .commit()
                .then(() => {
                  dispatch({ type: "DELETE_ATHLETE_SUCCESS" });
                })
                .catch((error) => {
                  dispatch({ type: "DELETE_ATHLETE_ERROR", error });
                });
            } else {
              dispatch({
                type: "DELETE_ATHLETE_ERROR",
                error: "ERROR : No User Found",
              });
            }
          });
        }
      })
      .catch((error) => {});
  };
};

export const editSchool = (schoolInfo) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    const schoolName = schoolInfo.editSchoolName;
    const schoolLogo = schoolInfo.newEditThumbnailImage;

    const schoolId = schoolInfo.editSchoolId;

    const schoolRef = firestore.collection("schools").doc(schoolId);
    schoolRef
      .update({
        name: schoolName,
      })
      .then(() => {
        if (schoolInfo.editImageCropped) {
          if (schoolInfo.editSchoolLogoChanged) {
            const storageRef = firebase.storage().ref();
            const fileName = "Logo";
            const uploadRef = storageRef
              .child("Schools")
              .child("Images")
              .child(schoolId)
              .child("Logo")
              .child(fileName);

            return uploadRef.put(schoolLogo).on(
              "state_changed",
              (snapshot) => {
                // dispatch({type: 'UPDATE_ATHLETE_PROGRESS', value: progress, media: 'Logo'})
              },
              (error) => {
                // dispatch({type: 'UPDATE_ATHLETE_ERROR', error})
              },
              () => {
                uploadRef
                  .getDownloadURL()
                  .then(function (downloadURL) {
                    const schoolRefId = firestore
                      .collection("schools")
                      .doc(schoolId);
                    schoolRefId
                      .update({
                        logo: downloadURL,
                      })
                      .then(() => {
                        dispatch({ type: "EDIT_SCHOOL_SUCCESS" });
                      })
                      .catch((error) => {
                        dispatch({ type: "EDIT_SCHOOL_ERROR" });
                      });
                  })
                  .catch((err) => {
                    dispatch({ type: "EDIT_SCHOOL_ERROR", err });
                  });
              }
            );
          } else {
            // logo did not change
            dispatch({ type: "EDIT_SCHOOL_SUCCESS" });
          }
        } else {
          dispatch({ type: "EDIT_SCHOOL_SUCCESS" });
        }
      })
      .catch((error) => {
        dispatch({ type: "EDIT_SCHOOL_ERROR", error });
      });
  };
};

export const addSchool = (schoolInfo) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    const schoolName = schoolInfo.schoolName;
    const schoolLogo = schoolInfo.newThumbnailImage;

    const schoolRef = firestore.collection("schools");
    schoolRef
      .add({
        name: schoolName,
      })
      .then((docRef) => {
        const storageRef = firebase.storage().ref();
        const fileName = "Logo";
        const uploadRef = storageRef
          .child("Schools")
          .child("Images")
          .child(docRef.id)
          .child("Logo")
          .child(fileName);

        return uploadRef.put(schoolLogo).on(
          "state_changed",
          (snapshot) => {},
          (error) => {},
          () => {
            uploadRef
              .getDownloadURL()
              .then(function (downloadURL) {
                const schoolRefId = firestore
                  .collection("schools")
                  .doc(docRef.id);
                schoolRefId
                  .set(
                    {
                      logo: downloadURL,
                    },
                    { merge: true }
                  )
                  .then(() => {
                    dispatch({ type: "ADD_SCHOOL_SUCCESS" });
                  })
                  .catch((error) => {
                    dispatch({ type: "ADD_SCHOOL_ERROR" });
                  });
              })
              .catch((err) => {
                dispatch({ type: "ADD_SCHOOL_ERROR", err });
              });
          }
        );
      })
      .catch((error) => {
        dispatch({ type: "ADD_SCHOOL_ERROR", error });
      });
  };
};
// Sport Position Players To Watch AddSkills EditSkills DeleteSkills
export const addSport = (newSport) => {
  const newSportField = newSport.toLowerCase();
  const toFirestore = {};
  toFirestore[newSportField] =
    newSport.charAt(0).toUpperCase() + newSport.slice(1);
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const sportRef = firestore.collection("sports").doc("games");
    const batch = firestore.batch();
    batch.set(sportRef, toFirestore, {
      merge: true,
    });

    batch
      .commit()
      .then(() => {
        dispatch({ type: "ADD_SPORT_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "ADD_SPORT_ERROR" });
      });
  };
};
export const addPosition = (newPosition, sport) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const positionRef = firestore.collection("sports").doc("position");
    const toSport = {};
    toSport[newPosition.charAt(0).toUpperCase() + newPosition.slice(1)] =
      newPosition.charAt(0).toUpperCase() + newPosition.slice(1);
    const toFirestore = {};
    toFirestore[sport] = toSport;
    const batch = firestore.batch();
    batch.set(positionRef, toFirestore, {
      merge: true,
    });

    batch
      .commit()
      .then(() => {
        dispatch({ type: "ADD_POSITION_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "ADD_POSITION_ERROR" });
      });
  };
};

export const editSportPosition = (sportInfo) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const sportRef = firestore.collection("sports").doc("games");
    const positionRef = firestore.collection("sports").doc("position");
    const batch = firestore.batch();

    const newSport = sportInfo.new.sport.toLowerCase();
    const key = sportInfo.key;
    const oldSport = sportInfo.old.sport;
    const newPositions = sportInfo.new.newPositions;
    const oldPositions = sportInfo.old.positions;
    const updateGames = {};
    updateGames[key] = newSport;
    const updatePosition = {};

    Object.keys(oldPositions).map((key) => {
      if (key in newPositions) {
        updatePosition[newPositions[key]] = newPositions[key];
      }
    });
    const newPositionObject = {};
    newPositionObject[newSport.charAt(0).toUpperCase() + newSport.slice(1)] =
      updatePosition;

    positionRef.update({
      [oldSport]: firebase.firestore.FieldValue.delete(),
    });
    batch.set(sportRef, updateGames, { merge: true });
    batch.set(positionRef, newPositionObject, { merge: true });
    batch
      .commit()
      .then(() => {})
      .catch((err) => {});
  };
};

export const deleteSport = (fromSport, fromPosition) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const sportRef = firestore.collection("sports").doc("games");
    const positionRef = firestore.collection("sports").doc("position");

    sportRef.update({
      [fromSport]: firebase.firestore.FieldValue.delete(),
    });
    positionRef.update({
      [fromPosition]: firebase.firestore.FieldValue.delete(),
    });
  };
};

export const deletePosition = (positionName, sportName) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const positionRef = firestore.collection("sports").doc("position");
    positionRef.update({
      [sportName + "." + positionName]: firebase.firestore.FieldValue.delete(),
    });
  };
};

// add player to watch data in firestore
// here data will come to this action as :
export const addPlayersToWatch = (dataArray) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const playerstowatchRef = firestore
      .collection("playerstowatch")
      .doc("playerstowatch");
    playerstowatchRef.delete();
    const batch = firestore.batch();
    const toPlayerstowatch = {};
    dataArray.map((value) => {
      return (toPlayerstowatch[value.key] = {
        player: value.player,
        url: value.url,
      });
    });
    batch.set(playerstowatchRef, toPlayerstowatch, {
      merge: true,
    });
    batch
      .commit()
      .then(() => {
        dispatch({ type: "ADD_PLAYERTOWATCH_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "ADD_PLAYERTOWATCH_ERROR" });
      });
  };
};

// add advocate data in firestore
// here data will come to this action as :
// {id: uid(8),name,title,facebook,instagram,twitter,linkedin,phone,email,thumbnail,info}
// Data To Database will be sent as :
// [{id:uid , name ,title , about,facebook ,instagram ,linkedin,twitter, createdAt : dateWhenCreated , modifiedAt : dateWhenModified ,phone,email,thumbnailUrl}]
export const addAdvocate = (data) => {
  let email;
  let password;
  let userUID;
  let skillsPlaylistsRef;
  let roleRef;
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const batch = firestore.batch();
    const currentTime = firebase.firestore.Timestamp.fromDate(new Date());
    const createUser = firebase.functions().httpsCallable("createUser");
    const role = { role: "advocate", createdAt: currentTime };

    password = data.password;
    email = data.email;
    createUser({ email, password })
      .then(({ data: user }) => {
        userUID = user.uid;
        roleRef = firestore.collection("userRole").doc(user.uid);
        skillsPlaylistsRef = firestore.collection("advocates").doc(user.uid);
        const toFirestore = {
          email,
          id: userUID,
          title: data.title,
          name: data.name,
          createdAt: currentTime,
          modifiedAt: currentTime,
          about: data.info,
          order: data.order,
        };
        if (data.facebook) {
          toFirestore.facebook = data.facebook;
        }
        if (data.instagram) {
          toFirestore.instagram = data.instagram;
        }
        if (data.twitter) {
          toFirestore.twitter = data.twitter;
        }
        if (data.linkedin) {
          toFirestore.linkedin = data.linkedin;
        }
        if (data.phone) {
          toFirestore.phone = data.phone;
        }

        batch.set(skillsPlaylistsRef, toFirestore, { merge: true });
        batch.set(roleRef, role, { merge: true });

        batch
          .commit()
          .then(() => {
            const storageRef = firebase.storage().ref();
            const fileName = "Thumbnail";
            const uploadRef = storageRef
              .child("advocates")
              .child("Images")
              .child(userUID)
              .child("Thumbnail")
              .child(fileName);

            return uploadRef.put(data.thumbnail).on(
              "state_changed",
              (snapshot) => {
                var progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                dispatch({
                  type: "ADD_ADVOCATE_PROGRESS",
                  value: progress,
                  media: "Thumbnail",
                });
              },
              (error) => {
                dispatch({ type: "ADD_ADVOCATE_ERROR", error });
              },
              () => {
                uploadRef
                  .getDownloadURL()
                  .then(function (downloadURL) {
                    const skillThumbnail = {
                      thumbnailUrl: downloadURL,
                    };
                    const roleUID = { userUID };
                    const batch = firestore.batch();
                    batch.update(skillsPlaylistsRef, skillThumbnail);
                    batch.update(roleRef, roleUID);

                    batch
                      .commit()
                      .then(() => {
                        dispatch({ type: "ADD_ADVOCATE_SUCCESS" });
                      })
                      .catch((err) => {
                        dispatch({ type: "ADD_ADVOCATE_ERROR", err });
                      });
                  })
                  .catch((err) => {
                    dispatch({ type: "ADD_ADVOCATE_ERROR", err });
                  });
              }
            );
          })
          .catch(() => {});
      })
      .catch((error) => {
        dispatch({ type: "ADD_ATHLETE_ERROR", error });
      });
  };
};

export const deleteAdvocate = (id) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const storageRef = firebase.storage().ref();
    const playlistID = firestore.collection("advocates").doc(id);
    playlistID.delete();
    const deleteRef = storageRef
      .child("advocates")
      .child("Images")
      .child(id)
      .child("Thumbnail");
    // deleteRef.delete();
  };
};
export const reorderAdvocates = (data) => {
  // [{}]
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const playlistID = firestore.collection("advocates");

    data.map((advocate) => {
      const tempRef = playlistID.doc(advocate.id);
      tempRef.delete();
      const currentTime = firebase.firestore.Timestamp.fromDate(new Date());
      const toFirestore = {
        id: advocate.id,
        name: advocate.name,
        title: advocate.title,
        thumbnailUrl: advocate.thumbnailUrl,
        about: advocate.about,
        phone: advocate.phone ? advocate.phone : null,
        email: advocate.email ? advocate.email : null,
        facebook: advocate.facebook ? advocate.facebook : null,
        instagram: advocate.instagram ? advocate.instagram : null,
        twitter: advocate.twitter ? advocate.twitter : null,
        linkedin: advocate.linkedin ? advocate.linkedin : null,
        order: advocate.order,
        createdAt: advocate.createdAt,
        modifiedAt: currentTime,
      };
      const batch = firestore.batch();
      batch.set(tempRef, toFirestore, { merge: true });
      batch
        .commit()
        .then(() => {})
        .catch(() => {});
    });
  };
};
export const editAdvocate = (data) => {
  let thumbnail;
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const batch = firestore.batch();
    const currentTime = firebase.firestore.Timestamp.fromDate(new Date());
    const advocatesRef = firestore.collection("advocates").doc(data.id);
    if (data.thumbnail) {
      thumbnail = data.thumbnail;
    }
    delete data.thumbnail;
    const toFirestore = {
      ...data,
      modifiedAt: currentTime,
    };
    batch.set(advocatesRef, toFirestore, { merge: true });

    batch.commit().then(() => {
      if (thumbnail) {
        const storageRef = firebase.storage().ref();
        const fileName = "Thumbnail";
        const uploadRef = storageRef
          .child("advocates")
          .child("Images")
          .child(data.id)
          .child("Thumbnail")
          .child(fileName);

        return uploadRef.put(thumbnail).on(
          "state_changed",
          (snapshot) => {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            dispatch({
              type: "UPDATE_ADVOCATE_PROGRESS",
              value: progress,
              media: "Thumbnail",
            });
          },
          (error) => {
            dispatch({ type: "UPDATE_ADVOCATE_ERROR", error });
          },
          () => {
            uploadRef
              .getDownloadURL()
              .then(function (downloadURL) {
                const skillThumbnail = {
                  thumbnailUrl: downloadURL,
                };

                const batch = firestore.batch();
                batch.update(advocatesRef, skillThumbnail);

                batch
                  .commit()
                  .then(() => {
                    dispatch({ type: "UPDATE_ADVOCATE_SUCCESS" });
                  })
                  .catch((err) => {
                    dispatch({ type: "UPDATE_ADVOCATE_ERROR", err });
                  });
              })
              .catch((err) => {
                dispatch({ type: "UPDATE_ADVOCATE_ERROR", err });
              });
          }
        );
      }
    });
  };
};

export const setActive = (id, activeStatus) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const batch = firestore.batch();
    const modifiedAt = firebase.firestore.Timestamp.fromDate(new Date());
    const playlistID = firestore.collection("skillsPlaylists").doc(id);

    const toFirestore = {
      modifiedAt: modifiedAt,
      active: activeStatus,
    };
    batch.set(playlistID, toFirestore, { merge: true });
    batch
      .commit()
      .then()
      .catch((err) => {});
  };
};

export const deletePlaylist = (id) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const storageRef = firebase.storage().ref();
    const playlistID = firestore.collection("skillsPlaylists").doc(id);
    playlistID.delete();
    const deleteRef = storageRef
      .child("skillPlaylists")
      .child("Images")
      .child(id)
      .child("Thumbnail");
    // deleteRef.delete();
  };
};
export const editPlaylist = (data) => {
  let thumbnail;
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const batch = firestore.batch();
    const currentTime = firebase.firestore.Timestamp.fromDate(new Date());
    const skillsPlaylistsRef = firestore
      .collection("skillsPlaylists")
      .doc(data.id);
    if (data.thumbnail) {
      thumbnail = data.thumbnail;
    }
    delete data.thumbnail;
    const toFirestore = {
      ...data,
      modifiedAt: currentTime,
    };
    batch.set(skillsPlaylistsRef, toFirestore, { merge: true });

    batch.commit().then(() => {
      if (thumbnail) {
        const storageRef = firebase.storage().ref();
        const fileName = "Thumbnail";
        const uploadRef = storageRef
          .child("skillPlaylists")
          .child("Images")
          .child(data.id)
          .child("Thumbnail")
          .child(fileName);

        return uploadRef.put(thumbnail).on(
          "state_changed",
          (snapshot) => {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            dispatch({
              type: "UPDATE_SKILL_PROGRESS",
              value: progress,
              media: "Thumbnail",
            });
          },
          (error) => {
            dispatch({ type: "UPDATE_SKILL_ERROR", error });
          },
          () => {
            uploadRef
              .getDownloadURL()
              .then(function (downloadURL) {
                const skillThumbnail = {
                  thumbnailUrl: downloadURL,
                };

                const batch = firestore.batch();
                batch.update(skillsPlaylistsRef, skillThumbnail);

                batch
                  .commit()
                  .then(() => {
                    dispatch({ type: "UPDATE_SKILL_SUCCESS" });
                  })
                  .catch((err) => {
                    dispatch({ type: "UPDATE_SKILL_ERROR", err });
                  });
              })
              .catch((err) => {
                dispatch({ type: "UPDATE_SKILL_ERROR", err });
              });
          }
        );
      }
    });
  };
};

// add skills playlist data in firestore
// here data will come to this action as :
// // {id:uid , title : Playlist Title , playlistUrl : playlistUrl , active: boolean (default : false) ,thumbnail:thumbnailImage}
// Data To Database will be sent as :
// [{id:uid , title : Playlist Title , playlistUrl : playlistUrl ,thumbnailUrl : thumbnailUrl , createdAt : dateWhenCreated , modifiedAt : dateWhenModified , active: boolean (default : false) }]
export const addSkills = (skillsData) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const batch = firestore.batch();
    const currentTime = firebase.firestore.Timestamp.fromDate(new Date());
    const skillsPlaylistsRef = firestore
      .collection("skillsPlaylists")
      .doc(skillsData.id);
    const toFirestore = {
      id: skillsData.id,
      title: skillsData.title,
      playlistUrl: skillsData.playlistUrl,
      createdAt: currentTime,
      modifiedAt: currentTime,
      active: false,
    };
    batch.set(skillsPlaylistsRef, toFirestore, { merge: true });

    batch.commit().then(() => {
      const storageRef = firebase.storage().ref();
      const fileName = "Thumbnail";
      const uploadRef = storageRef
        .child("skillPlaylists")
        .child("Images")
        .child(skillsData.id)
        .child("Thumbnail")
        .child(fileName);

      return uploadRef.put(skillsData.thumbnail).on(
        "state_changed",
        (snapshot) => {
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          dispatch({
            type: "ADD_SKILL_PROGRESS",
            value: progress,
            media: "Thumbnail",
          });
        },
        (error) => {
          dispatch({ type: "ADD_SKILL_ERROR", error });
        },
        () => {
          uploadRef
            .getDownloadURL()
            .then(function (downloadURL) {
              const skillThumbnail = {
                thumbnailUrl: downloadURL,
              };

              const batch = firestore.batch();
              batch.update(skillsPlaylistsRef, skillThumbnail);

              batch
                .commit()
                .then(() => {
                  dispatch({ type: "ADD_SKILL_SUCCESS" });
                })
                .catch((err) => {
                  dispatch({ type: "ADD_SKILL_ERROR", err });
                });
            })
            .catch((err) => {
              dispatch({ type: "ADD_SKILL_ERROR", err });
            });
        }
      );
    });
  };
};
export const getFilteredSport = (sport) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({ type: "GET_SPORT", value: sport });
  };
};
export const getFilteredDate = (date) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({ type: "GET_DATE", value: date });
  };
};
export const getFilteredCreator = (creator) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({ type: "GET_CREATOR", value: creator });
  };
};
export const getFilteredSuperSport = (sport) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({ type: "GET_SuperSPORT", value: sport });
  };
};
export const getFilteredSuperDate = (date) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({ type: "GET_SuperDATE", value: date });
  };
};
export const getFilteredSuperCreator = (creator) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({ type: "GET_SuperCREATOR", value: creator });
  };
};
export const deleteFieldFromAdvocate = (id, field) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const batch = firestore.batch();
    const modifiedAt = firebase.firestore.Timestamp.fromDate(new Date());
    const playlistID = firestore.collection("advocates").doc(id);
    const toFirestore = {
      modifiedAt: modifiedAt,
    };
    toFirestore[field] = null;
    batch.set(playlistID, toFirestore, { merge: true });
    batch
      .commit()
      .then()
      .catch((err) => {});
  };
};

export const addSeo = (tags, description, profileId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const batch = firestore.batch();
    const modifiedAt = firebase.firestore.Timestamp.fromDate(new Date());
    const seoRef = firestore.collection("testSEO").doc(profileId);
    const toFirestore = {
      tags,
      description,
      modifiedAt,
    };
    batch.set(seoRef, toFirestore, { merge: true });
    batch
      .commit()
      .then()
      .catch((err) => {});
  };
};

export const addEvent = (data) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    const batch = firestore.batch();
    const eventsRef = firestore.collection("events").doc(data.eventId);
    const toFirestore = {
      eventId: data.eventId,
      eventAdvocate: data.eventAdvocate,
      eventStartDate: firebase.firestore.Timestamp.fromDate(
        data.eventStartDate
      ),
      eventEndDate: firebase.firestore.Timestamp.fromDate(data.eventEndDate),
      eventSport: data.eventSport,
      eventName: data.eventName,
      eventLocation: data.eventLocation,
      eventCreator: data.eventCreator,
      eventAttenders: data.eventAttenders,
      eventStatus: data.eventStatus,
      eventUrl: data.eventUrl,
    };
    toFirestore.createdAt = firebase.firestore.Timestamp.fromDate(new Date());
    batch.set(eventsRef, toFirestore, { merge: true });
    batch
      .commit()
      .then()
      .catch((err) => {});
  };
};
export const deleteEventDoc = (id) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const eventID = firestore.collection("events").doc(id);
    eventID.delete();
  };
};
export const handleStatus = (id, status) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const eventsRef = firestore.collection("events").doc(id);
    const batch = firestore.batch();
    const toFirestore = { eventStatus: status };
    batch.set(eventsRef, toFirestore, { merge: true });
    batch
      .commit()
      .then()
      .catch((err) => {});
  };
};
export const handleAttenders = (id, attenders) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const eventsRef = firestore.collection("events").doc(id);
    const batch = firestore.batch();
    const toFirestore = { eventAttenders: attenders };
    batch.set(eventsRef, toFirestore, { merge: true });
    batch
      .commit()
      .then()
      .catch((err) => {});
  };
};
export const addPlans = (plan) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const plansRef = firestore.collection("testPriceList").doc(plan.planId);
    const batch = firestore.batch();
    const toFirestore = {
      ...plan,
      createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
    };
    batch.set(plansRef, toFirestore, { merge: true });
    batch
      .commit()
      .then()
      .catch((err) => {});
  };
};

export const handlePriceShow = (id, status) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const eventsRef = firestore.collection("testPriceList").doc(id);
    const batch = firestore.batch();
    const toFirestore = { show: status };
    batch.set(eventsRef, toFirestore, { merge: true });
    batch
      .commit()
      .then()
      .catch((err) => {});
  };
};
export const deletePlan = (id) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const eventsRef = firestore.collection("testPriceList").doc(id);
    eventsRef.delete();
  };
};
// Sport Position Players To Watch AddSkills EditSkills DeleteSkills ReOrder Completed Here

export const addAthlete = (athleteInfo) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    const email = athleteInfo.email;
    const password =
      Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);

    var athleteUid = null;
    const sport = athleteInfo.sport;
    const athleteClass = athleteInfo.class;

    const athleteClubTeamName = athleteInfo.teamName;
    const athleteCommitted = athleteInfo.committed;

    // remove space
    const advocate = athleteInfo.advocate.replace(/[^A-Z0-9]/gi, "");

    // create customUrl

    const firstName = athleteInfo.firstName;
    const lastName = athleteInfo.lastName;
    var firstLast = firstName + lastName;

    var count = 0;

    // remove spaces and special characters
    var athleteUrl = firstLast.replace(/[^A-Z0-9]/gi, "");

    checkCustomUrl();

    function checkCustomUrl() {
      const athleteRef = firestore.collection("athletes").doc(athleteUrl);

      athleteRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            // create different customUrl
            updateCustomUrl();
          } else {
            // customUrl does not exist ok to proceed
            createNewUser();
          }
        })
        .catch((error) => {
          dispatch({ type: "ADD_ATHLETE_ERROR", error });
        });
    }

    function updateCustomUrl() {
      count = count + 1;
      // remove numbers
      athleteUrl = athleteUrl.replace(/[^a-zA-Z ]/g, "");
      athleteUrl = athleteUrl + count;
      checkCustomUrl();
    }

    function createNewUser() {
      const createUser = firebase.functions().httpsCallable("createUser");

      createUser({ email, password })
        .then(({ data: user }) => {
          // add user to database

          athleteUid = user.uid;
          addToDatabase();
        })
        .catch((error) => {
          dispatch({ type: "ADD_ATHLETE_ERROR", error });
        });
    }

    function addToDatabase() {
      var userInfo = {
        email: email,
        firstName: firstName,
        lastName: lastName,
        customUrl: athleteUrl,
        sport: sport,
        advocate: advocate,
      };
      var athleteInfo = {
        customUrl: athleteUrl,
        class: athleteClass,
        sport: sport,
        firstName: firstName,
        lastName: lastName,
        act: 0,
        bats: "",
        throws: "",
        specialtyMetrics: "",
        classRank: "",
        clubTeamName: athleteClubTeamName,
        clubName: "",

        committed: athleteCommitted,
        parentTwoFirstName: "",
        parentOneFirstName: "",
        parentTwoLastName: "",
        parentOneLastName: "",
        height: "",
        weight: 0,
        gpa: 0,
        highSchoolCityState: "",
        highSchoolName: "",
        hometown: "",
        intendedMajor: "",
        jersey: "",
        ncaaId: 0,
        profilePublic: true,
        primaryPosition: "",
        primaryPositionFilter: "",
        sat: 0,
        secondaryPosition: "",
        thumbnail: "None",
      };
      var athleteAwardsHonors = {
        academicHonorOne: "",
        academicHonorTwo: "",
        academicHonorThree: "",
        academicHonorFour: "",
        academicHonorFive: "",
        academicHonorSix: "",
        academicHonorSeven: "",
        academicHonorEight: "",
        academicHonorNine: "",
        academicHonorTen: "",
        athleticAwardOne: "",
        athleticAwardTwo: "",
        athleticAwardThree: "",
        athleticAwardFour: "",
        athleticAwardFive: "",
        athleticAwardSix: "",
        athleticAwardSeven: "",
        athleticAwardEight: "",
        athleticAwardNine: "",
        athleticAwardTen: "",
      };
      var athleteCoaches = {
        clubCoachEmail: "",
        clubCoachName: "",
        clubCoachPhone: "",
        highSchoolCoachEmail: "",
        highSchoolCoachName: "",
        highSchoolCoachPhone: "",
        hittingCoachEmail: "",
        hittingCoachName: "",
        hittingCoachPhone: "",
        pitchingCoachEmail: "",
        pitchingCoachName: "",
        pitchingCoachPhone: "",
      };
      var athleteExtras = {
        extraOne: "",
        extraTwo: "",
        extraThree: "",
        extraFour: "",
        extraFive: "",
        hobbyOne: "",
        hobbyTwo: "",
        hobbyThree: "",
        hobbyFour: "",
        hobbyFive: "",
        strengthOne: "",
        strengthTwo: "",
        strengthThree: "",
        strengthFour: "",
        strengthFive: "",
      };
      var athleteImages = {
        imageOne: "None",
        imageTwo: "None",
        imageThree: "None",
        imageFour: "None",
        imageFive: "None",
      };
      let athleteHighSchoolSchedule = {
        imageHighSchoolOne: "None",
        imageHighSchoolTwo: "None",
        imageHighSchoolThree: "None",
        imageHighSchoolFour: "None",
        imageHighSchoolFive: "None",
      };
      var athleteSocialMedia = {
        agl: "",
        facebook: "",
        hudl: "",
        instagram: "",
        twitter: "",
        youTube: "",
      };
      var athleteVideo = {
        videoOne: "None",
        videoTwo: "None",
        videoThree: "None",
        videoFour: "None",
      };

      const batch = firestore.batch();

      const addToUsers = firestore.collection("users").doc(athleteUid);
      batch.set(addToUsers, userInfo, { merge: true });

      const addToAdmin = firestore.collection("adminAthletes").doc(athleteUid);
      batch.set(addToAdmin, athleteInfo, { merge: true });

      const addToAdminAwardsHonors = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("awardsHonors");
      batch.set(addToAdminAwardsHonors, athleteAwardsHonors, { merge: true });

      const addToAdminCoaches = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("coaches");
      batch.set(addToAdminCoaches, athleteCoaches, { merge: true });

      const addToAdminExtras = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("extras");
      batch.set(addToAdminExtras, athleteExtras, { merge: true });

      const addToAdminImages = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("images");
      batch.set(addToAdminImages, athleteImages, { merge: true });

      const addToAdminHighSchoolImages = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("highschoolschedule");
      batch.set(addToAdminHighSchoolImages, athleteHighSchoolSchedule, {
        merge: true,
      });

      const addToAdminSocialMedia = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("socialMedia");
      batch.set(addToAdminSocialMedia, athleteSocialMedia, { merge: true });

      const addToAdminVideo = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("video");
      batch.set(addToAdminVideo, athleteVideo, { merge: true });

      const addToAthletes = firestore.collection("athletes").doc(athleteUrl);
      batch.set(addToAthletes, athleteInfo, { merge: true });

      const addToAwardsHonors = firestore
        .collection("athletes")
        .doc(athleteUrl)
        .collection("profile")
        .doc("awardsHonors");
      batch.set(addToAwardsHonors, athleteAwardsHonors, { merge: true });

      const addToCoaches = firestore
        .collection("athletes")
        .doc(athleteUrl)
        .collection("profile")
        .doc("coaches");
      batch.set(addToCoaches, athleteCoaches, { merge: true });

      const addToExtras = firestore
        .collection("athletes")
        .doc(athleteUrl)
        .collection("profile")
        .doc("extras");
      batch.set(addToExtras, athleteExtras, { merge: true });

      const addToImages = firestore
        .collection("athletes")
        .doc(athleteUrl)
        .collection("profile")
        .doc("images");
      batch.set(addToImages, athleteImages, { merge: true });

      const addToHighSchoolImages = firestore
        .collection("athletes")
        .doc(athleteUrl)
        .collection("profile")
        .doc("images");
      batch.set(addToHighSchoolImages, athleteHighSchoolSchedule, {
        merge: true,
      });

      const addToSocialMedia = firestore
        .collection("athletes")
        .doc(athleteUrl)
        .collection("profile")
        .doc("socialMedia");
      batch.set(addToSocialMedia, athleteSocialMedia, { merge: true });

      const addToVideo = firestore
        .collection("athletes")
        .doc(athleteUrl)
        .collection("profile")
        .doc("video");
      batch.set(addToVideo, athleteVideo, { merge: true });

      batch
        .commit()
        .then(() => {
          dispatch({ type: "ADD_ATHLETE_SUCCESS" });
        })
        .catch((error) => dispatch({ type: "ADD_ATHLETE_ERROR", error }));
    }
  };
};

export const updateAthleteEvents = (athleteInfo, athleteId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    var athleteEventsStuff = {
      eventOneName: athleteInfo.eventOneName,
      eventOneUrl: athleteInfo.eventOneUrl,
      eventOneDate: athleteInfo.eventOneDate,
      eventTwoName: athleteInfo.eventTwoName,
      eventTwoUrl: athleteInfo.eventTwoUrl,
      eventTwoDate: athleteInfo.eventTwoDate,
      eventThreeName: athleteInfo.eventThreeName,
      eventThreeUrl: athleteInfo.eventThreeUrl,
      eventThreeDate: athleteInfo.eventThreeDate,
      eventFourName: athleteInfo.eventFourName,
      eventFourUrl: athleteInfo.eventFourUrl,
      eventFourDate: athleteInfo.eventFourDate,
      eventFiveName: athleteInfo.eventFiveName,
      eventFiveUrl: athleteInfo.eventFiveUrl,
      eventFiveDate: athleteInfo.eventFiveDate,
      eventSixName: athleteInfo.eventSixName,
      eventSixUrl: athleteInfo.eventSixUrl,
      eventSixDate: athleteInfo.eventSixDate,
    };

    const batch = firestore.batch();

    const athleteAdminEventsRef = firestore
      .collection("adminAthletes")
      .doc(athleteId)
      .collection("profile")
      .doc("events");
    batch.set(athleteAdminEventsRef, athleteEventsStuff, { merge: true });

    const athleteEventsRef = firestore
      .collection("athletes")
      .doc(athleteInfo.customUrl)
      .collection("profile")
      .doc("events");
    batch.set(athleteEventsRef, athleteEventsStuff, { merge: true });

    batch
      .commit()
      .then(() => {
        dispatch({ type: "UPDATE_EVENTS_SUCCESS" });
      })
      .catch((error) => {
        dispatch({ type: "UPDATE_EVENTS_ERROR", error });
      });
  };
};

export const updateAthlete = (athleteInfo, athleteId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const oldEntry = firebase.functions().httpsCallable("oldEntry");
    const firestore = getFirestore();
    var athleteImageRef = firestore
      .collection("athletes")
      .doc(athleteInfo.customUrl)
      .collection("profile")
      .doc("images");
    var athleteAdminImageRef = firestore
      .collection("adminAthletes")
      .doc(athleteId)
      .collection("profile")
      .doc("images");
    var athleteVideoRef = firestore
      .collection("athletes")
      .doc(athleteInfo.customUrl)
      .collection("profile")
      .doc("video");
    var athleteAdminVideoRef = firestore
      .collection("adminAthletes")
      .doc(athleteId)
      .collection("profile")
      .doc("video");

    const getNewData = (id) => {
      let data = {};
      // report ref
      const reportRef = firestore.collection("updateReport").doc(id);
      const currentTime = firebase.firestore.Timestamp.fromDate(new Date());

      //  athlete data
      const athleteRef = firestore.collection("adminAthletes").doc(id);
      const imageRef = athleteRef.collection("profile").doc("images");
      const videoRef = athleteRef.collection("profile").doc("video");
      const coachRef = athleteRef.collection("profile").doc("coaches");
      const awardsHonorsRef = athleteRef
        .collection("profile")
        .doc("awardsHonors");
      const extrasRef = athleteRef.collection("profile").doc("extras");
      const socialRef = athleteRef.collection("profile").doc("socialMedia");

      athleteRef.get().then((doc) => {
        if (doc.exists) {
          const athlete = doc.data();
          data = { ...athlete, ...data };

          const InitialBatch = firestore.batch();
          InitialBatch.set(
            reportRef,
            { id, new: { ...data, modifiedAt: currentTime } },
            { merge: true }
          );

          InitialBatch.commit().then(() => {
            imageRef.get().then((doc) => {
              if (doc.exists) {
                const BatchReport = firestore.batch();
                const images = doc.data();
                data = { ...images, ...data };

                BatchReport.set(reportRef, { id, new: data }, { merge: true });
                BatchReport.commit();
              }
            });

            videoRef.get().then((doc) => {
              if (doc.exists) {
                const BatchReport = firestore.batch();

                const videos = doc.data();
                data = { ...videos, ...data };
                BatchReport.set(reportRef, { id, new: data }, { merge: true });
                BatchReport.commit();
              }
            });

            coachRef.get().then((doc) => {
              if (doc.exists) {
                const BatchReport = firestore.batch();

                const coaches = doc.data();
                data = { ...coaches, ...data };
                BatchReport.set(reportRef, { id, new: data }, { merge: true });
                BatchReport.commit();
              }
            });

            awardsHonorsRef.get().then((doc) => {
              if (doc.exists) {
                const BatchReport = firestore.batch();
                const awards = doc.data();
                data = { ...awards, ...data };
                BatchReport.set(reportRef, { id, new: data }, { merge: true });
                BatchReport.commit();
              }
            });

            extrasRef.get().then((doc) => {
              if (doc.exists) {
                const BatchReport = firestore.batch();
                const extras = doc.data();
                data = { ...extras, ...data };
                BatchReport.set(reportRef, { id, new: data }, { merge: true });
                BatchReport.commit();
              }
            });

            socialRef.get().then((doc) => {
              if (doc.exists) {
                const BatchReport = firestore.batch();
                const socials = doc.data();
                data = { ...socials, ...data };
                BatchReport.set(reportRef, { id, new: data }, { merge: true });
                BatchReport.commit();
              }
            });
          });
        }
      });
    };
    const sendingRequestToOldData = {
      id: athleteId,
      oldData: athleteInfo.oldData,
    };
    oldEntry(sendingRequestToOldData).then(() => {
      const athleteHeight = athleteInfo.height.replace(/\s/g, "");

      var athleteStuff = {
        customUrl: athleteInfo.customUrl,

        firstName: athleteInfo.firstName,
        lastName: athleteInfo.lastName,
        hometown: athleteInfo.hometown,
        class: athleteInfo.class,
        sport: athleteInfo.sport,
        committed: athleteInfo.committed,

        committedSchoolId: athleteInfo.committedSchoolId,
        committedSchool: athleteInfo.committedSchool,

        primaryPosition: athleteInfo.primaryPosition,
        primaryPositionFilter: athleteInfo.primaryPositionFilter,
        secondaryPosition: athleteInfo.secondaryPosition,
        bats: athleteInfo.bats,
        throws: athleteInfo.throws,
        specialtyMetrics: athleteInfo.specialtyMetrics,
        parentOneFirstName: athleteInfo.parentOneFirstName,
        parentTwoFirstName: athleteInfo.parentTwoFirstName,
        parentOneLastName: athleteInfo.parentOneLastName,
        parentTwoLastName: athleteInfo.parentTwoLastName,
        clubName: athleteInfo.clubName,
        clubTeamName: athleteInfo.clubTeamName,
        jersey: athleteInfo.jersey,
        height: athleteHeight,
        weight: athleteInfo.weight,
        ncaaId: athleteInfo.ncaaId,
        gpa: athleteInfo.gpa,
        act: athleteInfo.act,
        sat: athleteInfo.sat,
        classRank: athleteInfo.classRank,
        highSchoolName: athleteInfo.highSchoolName,
        highSchoolCityState: athleteInfo.highSchoolCityState,
        intendedMajor: athleteInfo.intendedMajor,
      };

      var athleteAwardsHonors = {
        academicHonorOne: athleteInfo.academicHonorOne,
        academicHonorTwo: athleteInfo.academicHonorTwo,
        academicHonorThree: athleteInfo.academicHonorThree,
        academicHonorFour: athleteInfo.academicHonorFour,
        academicHonorFive: athleteInfo.academicHonorFive,
        academicHonorSix: athleteInfo.academicHonorSix,
        academicHonorSeven: athleteInfo.academicHonorSeven,
        academicHonorEight: athleteInfo.academicHonorEight,
        academicHonorNine: athleteInfo.academicHonorNine,
        academicHonorTen: athleteInfo.academicHonorTen,
        athleticAwardOne: athleteInfo.athleticAwardOne,
        athleticAwardTwo: athleteInfo.athleticAwardTwo,
        athleticAwardThree: athleteInfo.athleticAwardThree,
        athleticAwardFour: athleteInfo.athleticAwardFour,
        athleticAwardFive: athleteInfo.athleticAwardFive,
        athleticAwardSix: athleteInfo.athleticAwardSix,
        athleticAwardSeven: athleteInfo.athleticAwardSeven,
        athleticAwardEight: athleteInfo.athleticAwardEight,
        athleticAwardNine: athleteInfo.athleticAwardNine,
        athleticAwardTen: athleteInfo.athleticAwardTen,
      };

      var athleteCoaches = {
        clubCoachName: athleteInfo.clubCoachName,
        clubCoachPhone: athleteInfo.clubCoachPhone,
        clubCoachEmail: athleteInfo.clubCoachEmail,
        highSchoolCoachName: athleteInfo.highSchoolCoachName,
        highSchoolCoachPhone: athleteInfo.highSchoolCoachPhone,
        highSchoolCoachEmail: athleteInfo.highSchoolCoachEmail,
        hittingCoachName: athleteInfo.hittingCoachName,
        hittingCoachPhone: athleteInfo.hittingCoachPhone,
        hittingCoachEmail: athleteInfo.hittingCoachEmail,
        pitchingCoachName: athleteInfo.pitchingCoachName,
        pitchingCoachPhone: athleteInfo.pitchingCoachPhone,
        pitchingCoachEmail: athleteInfo.pitchingCoachEmail,

        catchingCoachName: athleteInfo.catchingCoachName,
        catchingCoachPhone: athleteInfo.catchingCoachPhone,
        catchingCoachEmail: athleteInfo.catchingCoachEmail,

        specialtyCoachName: athleteInfo.specialtyCoachName,
        specialtyCoachFocus: athleteInfo.specialtyCoachFocus,
        specialtyCoachPhone: athleteInfo.specialtyCoachPhone,
        specialtyCoachEmail: athleteInfo.specialtyCoachEmail,
      };

      var athleteExtras = {
        strengthOne: athleteInfo.athleticStrengthOne,
        strengthTwo: athleteInfo.athleticStrengthTwo,
        strengthThree: athleteInfo.athleticStrengthThree,
        strengthFour: athleteInfo.athleticStrengthFour,
        strengthFive: athleteInfo.athleticStrengthFive,
        extraOne: athleteInfo.athleticExtraOne,
        extraTwo: athleteInfo.athleticExtraTwo,
        extraThree: athleteInfo.athleticExtraThree,
        extraFour: athleteInfo.athleticExtraFour,
        extraFive: athleteInfo.athleticExtraFive,
        hobbyOne: athleteInfo.athleticHobbyOne,
        hobbyTwo: athleteInfo.athleticHobbyTwo,
        hobbyThree: athleteInfo.athleticHobbyThree,
        hobbyFour: athleteInfo.athleticHobbyFour,
        hobbyFive: athleteInfo.athleticHobbyFive,
      };

      var athleteSocialMedia = {
        agl: athleteInfo.agl,
        facebook: athleteInfo.facebook,
        hudl: athleteInfo.hudl,
        instagram: athleteInfo.instagram,
        twitter: athleteInfo.twitter,
        youTube: athleteInfo.youTube,

        calendar: athleteInfo.athleteCalendar,
      };
      let athleteVideoTitles = {};
      if (athleteInfo.videoOneTitle) {
        athleteVideoTitles.videoOneTitle = athleteInfo.videoOneTitle;
      }
      if (athleteInfo.videoTwoTitle) {
        athleteVideoTitles.videoTwoTitle = athleteInfo.videoTwoTitle;
      }
      if (athleteInfo.videoThreeTitle) {
        athleteVideoTitles.videoThreeTitle = athleteInfo.videoThreeTitle;
      }
      if (athleteInfo.videoFourTitle) {
        athleteVideoTitles.videoFourTitle = athleteInfo.videoFourTitle;
      }
      const batch = firestore.batch();

      // update athlete info

      const athleteAdminRef = firestore
        .collection("adminAthletes")
        .doc(athleteId);
      batch.set(athleteAdminRef, athleteStuff, { merge: true });

      const athleteRef = firestore
        .collection("athletes")
        .doc(athleteInfo.customUrl);
      batch.set(athleteRef, athleteStuff, { merge: true });
      // update coach info

      const athleteAdminCoachRef = firestore
        .collection("adminAthletes")
        .doc(athleteId)
        .collection("profile")
        .doc("coaches");
      batch.set(athleteAdminCoachRef, athleteCoaches, { merge: true });

      const athleteCoachRef = firestore
        .collection("athletes")
        .doc(athleteInfo.customUrl)
        .collection("profile")
        .doc("coaches");
      batch.update(athleteCoachRef, athleteCoaches);

      // update awardsHonors

      const athleteAdminAwardsHonorsRef = firestore
        .collection("adminAthletes")
        .doc(athleteId)
        .collection("profile")
        .doc("awardsHonors");
      batch.update(athleteAdminAwardsHonorsRef, athleteAwardsHonors);

      const athleteAwardsHonorsRef = firestore
        .collection("athletes")
        .doc(athleteInfo.customUrl)
        .collection("profile")
        .doc("awardsHonors");
      batch.update(athleteAwardsHonorsRef, athleteAwardsHonors);

      // update extras

      const athleteAdminExtrasRef = firestore
        .collection("adminAthletes")
        .doc(athleteId)
        .collection("profile")
        .doc("extras");
      batch.update(athleteAdminExtrasRef, athleteExtras);

      const athleteExtrasRef = firestore
        .collection("athletes")
        .doc(athleteInfo.customUrl)
        .collection("profile")
        .doc("extras");
      batch.update(athleteExtrasRef, athleteExtras);

      // update socialMedia

      const athleteAdminSocialRef = firestore
        .collection("adminAthletes")
        .doc(athleteId)
        .collection("profile")
        .doc("socialMedia");
      batch.set(athleteAdminSocialRef, athleteSocialMedia, { merge: true });

      const athleteSocialRef = firestore
        .collection("athletes")
        .doc(athleteInfo.customUrl)
        .collection("profile")
        .doc("socialMedia");
      batch.set(athleteSocialRef, athleteSocialMedia, { merge: true });

      batch.set(athleteVideoRef, athleteVideoTitles, { merge: true });
      batch.set(athleteAdminVideoRef, athleteVideoTitles, { merge: true });
      batch.commit().then(() => {
        if (athleteInfo.imageCropped) {
          if (athleteInfo.thumbnailChanged) {
            const storageRef = firebase.storage().ref();
            const fileName = "Thumbnail";
            const uploadRef = storageRef
              .child("Athletes")
              .child("Images")
              .child(athleteId)
              .child("Thumbnail")
              .child(fileName);

            return uploadRef.put(athleteInfo.thumbnail).on(
              "state_changed",
              (snapshot) => {
                var progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                dispatch({
                  type: "UPDATE_ATHLETE_PROGRESS",
                  value: progress,
                  media: "Thumbnail",
                });
              },
              (error) => {
                dispatch({ type: "UPDATE_ATHLETE_ERROR", error });
              },
              () => {
                uploadRef
                  .getDownloadURL()
                  .then(function (downloadURL) {
                    var athleteThumbnail = {
                      thumbnail: downloadURL,
                    };

                    const batch = firestore.batch();
                    batch.update(athleteAdminRef, athleteThumbnail);
                    batch.update(athleteRef, athleteThumbnail);

                    batch
                      .commit()
                      .then(() => {
                        imageOneChanged();
                      })
                      .catch((err) => {
                        dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
                      });
                  })
                  .catch((err) => {
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
                  });
              }
            );
          } else {
            // thumbnail did not change
            // check image one changed
            imageOneChanged();
          }
        } else {
          getNewData(athleteId);

          dispatch({ type: "UPDATE_ATHLETE_SUCCESS" });
        }
      });

      function imageOneChanged() {
        if (athleteInfo.imageOneChanged) {
          const storageRef = firebase.storage().ref();
          const fileName = "ImageOne";
          const uploadRef = storageRef
            .child("Athletes")
            .child("Images")
            .child(athleteId)
            .child("Images")
            .child(fileName);

          return uploadRef.put(athleteInfo.imageOne).on(
            "state_changed",
            (snapshot) => {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              dispatch({
                type: "UPDATE_ATHLETE_PROGRESS",
                value: progress,
                media: "Image One",
              });
            },
            (error) => {
              dispatch({ type: "UPDATE_ATHLETE_ERROR", error });
            },
            () => {
              uploadRef.getDownloadURL().then(function (downloadURL) {
                var athleteImageOne = {
                  imageOne: downloadURL,
                };

                const batch = firestore.batch();
                batch.update(athleteAdminImageRef, athleteImageOne);
                batch.update(athleteImageRef, athleteImageOne);

                batch
                  .commit()
                  .then(() => {
                    imageTwoChanged();
                  })
                  .catch((err) => {
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
                  });
              });
            }
          );
        } else {
          // image one did not change
          // check image two
          imageTwoChanged();
        }
      }
      function imageTwoChanged() {
        if (athleteInfo.imageTwoChanged) {
          const storageRef = firebase.storage().ref();
          const fileName = "ImageTwo";
          const uploadRef = storageRef
            .child("Athletes")
            .child("Images")
            .child(athleteId)
            .child("Images")
            .child(fileName);

          return uploadRef.put(athleteInfo.imageTwo).on(
            "state_changed",
            (snapshot) => {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              dispatch({
                type: "UPDATE_ATHLETE_PROGRESS",
                value: progress,
                media: "Image Two",
              });
            },
            (error) => {
              dispatch({ type: "UPDATE_ATHLETE_ERROR", error });
            },
            () => {
              uploadRef.getDownloadURL().then(function (downloadURL) {
                var athleteImageTwo = {
                  imageTwo: downloadURL,
                };

                const batch = firestore.batch();
                batch.update(athleteAdminImageRef, athleteImageTwo);
                batch.update(athleteImageRef, athleteImageTwo);

                batch
                  .commit()
                  .then(() => {
                    imageThreeChanged();
                  })
                  .catch((err) => {
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
                  });
              });
            }
          );
        } else {
          // image two did not change
          // check image three change
          imageThreeChanged();
        }
      }
      function imageThreeChanged() {
        if (athleteInfo.imageThreeChanged) {
          const storageRef = firebase.storage().ref();
          const fileName = "ImageThree";
          const uploadRef = storageRef
            .child("Athletes")
            .child("Images")
            .child(athleteId)
            .child("Images")
            .child(fileName);

          return uploadRef.put(athleteInfo.imageThree).on(
            "state_changed",
            (snapshot) => {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              dispatch({
                type: "UPDATE_ATHLETE_PROGRESS",
                value: progress,
                media: "Image Three",
              });
            },
            (error) => {
              dispatch({ type: "UPDATE_ATHLETE_ERROR", error });
            },
            () => {
              uploadRef.getDownloadURL().then(function (downloadURL) {
                var athleteImageThree = {
                  imageThree: downloadURL,
                };

                const batch = firestore.batch();
                batch.update(athleteAdminImageRef, athleteImageThree);
                batch.update(athleteImageRef, athleteImageThree);

                batch
                  .commit()
                  .then(() => {
                    imageFourChanged();
                  })
                  .catch((err) => {
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
                  });
              });
            }
          );
        } else {
          // image three did not change
          // check image four change
          imageFourChanged();
        }
      }
      function imageFourChanged() {
        if (athleteInfo.imageFourChanged) {
          const storageRef = firebase.storage().ref();
          const fileName = "ImageFour";
          const uploadRef = storageRef
            .child("Athletes")
            .child("Images")
            .child(athleteId)
            .child("Images")
            .child(fileName);

          return uploadRef.put(athleteInfo.imageFour).on(
            "state_changed",
            (snapshot) => {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              dispatch({
                type: "UPDATE_ATHLETE_PROGRESS",
                value: progress,
                media: "Image Four",
              });
            },
            (error) => {
              dispatch({ type: "UPDATE_ATHLETE_ERROR", error });
            },
            () => {
              uploadRef.getDownloadURL().then(function (downloadURL) {
                var athleteImageFour = {
                  imageFour: downloadURL,
                };

                const batch = firestore.batch();
                batch.update(athleteAdminImageRef, athleteImageFour);
                batch.update(athleteImageRef, athleteImageFour);

                batch
                  .commit()
                  .then(() => {
                    imageFiveChanged();
                  })
                  .catch((err) => {
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
                  });
              });
            }
          );
        } else {
          // image four did not change
          // check image five change
          imageFiveChanged();
        }
      }
      function imageFiveChanged() {
        if (athleteInfo.imageFiveChanged) {
          const storageRef = firebase.storage().ref();
          const fileName = "ImageFive";
          const uploadRef = storageRef
            .child("Athletes")
            .child("Images")
            .child(athleteId)
            .child("Images")
            .child(fileName);

          return uploadRef.put(athleteInfo.imageFive).on(
            "state_changed",
            (snapshot) => {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              dispatch({
                type: "UPDATE_ATHLETE_PROGRESS",
                value: progress,
                media: "Image Five",
              });
            },
            (error) => dispatch({ type: "UPDATE_ATHLETE_ERROR", error }),
            () => {
              uploadRef.getDownloadURL().then(function (downloadURL) {
                var athleteImageFive = {
                  imageFive: downloadURL,
                };

                const batch = firestore.batch();
                batch.update(athleteAdminImageRef, athleteImageFive);
                batch.update(athleteImageRef, athleteImageFive);

                batch
                  .commit()
                  .then(() => imageTranscriptChanged())
                  .catch((err) =>
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err })
                  );
              });
            }
          );
        } else {
          // image five did not change
          // check imageTranscript change
          imageTranscriptChanged();
        }
      }

      function imageTranscriptChanged() {
        if (athleteInfo.transcriptImageChanged) {
          const storageRef = firebase.storage().ref();
          const fileName = "ImageTranscript";
          const uploadRef = storageRef
            .child("Athletes")
            .child("Images")
            .child(athleteId)
            .child("Images")
            .child(fileName);

          return uploadRef.put(athleteInfo.transcriptImage).on(
            "state_changed",
            (snapshot) => {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              dispatch({
                type: "UPDATE_ATHLETE_PROGRESS",
                value: progress,
                media: "Image Transcript",
              });
            },
            (error) => {
              dispatch({ type: "UPDATE_ATHLETE_ERROR", error });
            },
            () => {
              uploadRef.getDownloadURL().then(function (downloadURL) {
                var athleteImageTranscript = {
                  transcriptImage: downloadURL,
                };

                const batch = firestore.batch();
                batch.set(athleteAdminImageRef, athleteImageTranscript, {
                  merge: true,
                });
                batch.set(athleteImageRef, athleteImageTranscript, {
                  merge: true,
                });

                batch
                  .commit()
                  .then(() => imageSatChanged())
                  .catch((err) =>
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err })
                  );
              });
            }
          );
        } else {
          // imageTranscript did not change
          // check imageSat change
          imageSatChanged();
        }
      }

      function imageSatChanged() {
        if (athleteInfo.satScoreImageChanged) {
          const storageRef = firebase.storage().ref();
          const fileName = "ImageSatScore";
          const uploadRef = storageRef
            .child("Athletes")
            .child("Images")
            .child(athleteId)
            .child("Images")
            .child(fileName);

          return uploadRef.put(athleteInfo.satScoreImage).on(
            "state_changed",
            (snapshot) => {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              dispatch({
                type: "UPDATE_ATHLETE_PROGRESS",
                value: progress,
                media: "Image SAT Score",
              });
            },
            (error) => dispatch({ type: "UPDATE_ATHLETE_ERROR", error }),
            () => {
              uploadRef.getDownloadURL().then(function (downloadURL) {
                var athleteImageSat = {
                  satScoreImage: downloadURL,
                };

                const batch = firestore.batch();
                batch.set(athleteAdminImageRef, athleteImageSat, {
                  merge: true,
                });
                batch.set(athleteImageRef, athleteImageSat, { merge: true });

                batch
                  .commit()
                  .then(() => {
                    imageHighSchoolOneChanged();
                  })
                  .catch((err) =>
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err })
                  );
              });
            }
          );
        } else {
          // image SAT did not change
          // check HighSchool Schedule One
          imageHighSchoolOneChanged();
        }
      }

      function imageHighSchoolOneChanged() {
        if (athleteInfo.imageHighSchoolOneChanged) {
          const storageRef = firebase.storage().ref();
          const fileName = "ImageHighSchoolOne";
          const uploadRef = storageRef
            .child("Athletes")
            .child("HighSchoolImages")
            .child(athleteId)
            .child("HighSchoolImages")
            .child(fileName);

          return uploadRef.put(athleteInfo.imageHighSchoolOne).on(
            "state_changed",
            (snapshot) => {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              dispatch({
                type: "UPDATE_ATHLETE_PROGRESS",
                value: progress,
                media: "Image HighSchool Schedule One",
              });
            },
            (error) => dispatch({ type: "UPDATE_ATHLETE_ERROR", error }),
            () => {
              uploadRef.getDownloadURL().then(function (downloadURL) {
                let athleteHighSchoolScheduleOne = {
                  imageHighSchoolOne: downloadURL,
                };

                const batch = firestore.batch();
                batch.set(athleteAdminImageRef, athleteHighSchoolScheduleOne, {
                  merge: true,
                });
                batch.set(athleteImageRef, athleteHighSchoolScheduleOne, {
                  merge: true,
                });

                batch
                  .commit()
                  .then(() => imageHighSchoolTwoChanged())
                  .catch((err) => {
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
                  });
              });
            }
          );
        } else {
          // HighSchool Schedule One didn't change
          // check HighSchool Schedule Two
          imageHighSchoolTwoChanged();
        }
      }
      function imageHighSchoolTwoChanged() {
        if (athleteInfo.imageHighSchoolTwoChanged) {
          const storageRef = firebase.storage().ref();
          const fileName = "ImageHighSchoolTwo";
          const uploadRef = storageRef
            .child("Athletes")
            .child("HighSchoolImages")
            .child(athleteId)
            .child("HighSchoolImages")
            .child(fileName);

          return uploadRef.put(athleteInfo.imageHighSchoolTwo).on(
            "state_changed",
            (snapshot) => {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              dispatch({
                type: "UPDATE_ATHLETE_PROGRESS",
                value: progress,
                media: "Image HighSchool Schedule Two",
              });
            },
            (error) => dispatch({ type: "UPDATE_ATHLETE_ERROR", error }),
            () => {
              uploadRef.getDownloadURL().then(function (downloadURL) {
                let athleteHighSchoolScheduleTwo = {
                  imageHighSchoolTwo: downloadURL,
                };

                const batch = firestore.batch();
                batch.set(athleteAdminImageRef, athleteHighSchoolScheduleTwo, {
                  merge: true,
                });
                batch.set(athleteImageRef, athleteHighSchoolScheduleTwo, {
                  merge: true,
                });

                batch
                  .commit()
                  .then(() => imageHighSchoolThreeChanged())
                  .catch((err) =>
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err })
                  );
              });
            }
          );
        } else {
          // HighSchool Schedule Two didn't change
          // check HighSchool Schedule Three
          imageHighSchoolThreeChanged();
        }
      }

      function imageHighSchoolThreeChanged() {
        if (athleteInfo.imageHighSchoolThreeChanged) {
          const storageRef = firebase.storage().ref();
          const fileName = "ImageHighSchoolThree";
          const uploadRef = storageRef
            .child("Athletes")
            .child("HighSchoolImages")
            .child(athleteId)
            .child("HighSchoolImages")
            .child(fileName);

          return uploadRef.put(athleteInfo.imageHighSchoolThree).on(
            "state_changed",
            (snapshot) => {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              dispatch({
                type: "UPDATE_ATHLETE_PROGRESS",
                value: progress,
                media: "Image HighSchool Schedule Three",
              });
            },
            (error) => dispatch({ type: "UPDATE_ATHLETE_ERROR", error }),
            () => {
              uploadRef.getDownloadURL().then(function (downloadURL) {
                let athleteHighSchoolScheduleThree = {
                  imageHighSchoolThree: downloadURL,
                };

                const batch = firestore.batch();
                batch.set(
                  athleteAdminImageRef,
                  athleteHighSchoolScheduleThree,
                  {
                    merge: true,
                  }
                );
                batch.set(athleteImageRef, athleteHighSchoolScheduleThree, {
                  merge: true,
                });

                batch
                  .commit()
                  .then(() => {
                    imageHighSchoolFourChanged();
                  })
                  .catch((err) =>
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err })
                  );
              });
            }
          );
        } else {
          // HighSchool Schedule Three didn't change
          // check HighSchool Schedule Four
          imageHighSchoolFourChanged();
        }
      }
      function imageHighSchoolFourChanged() {
        if (athleteInfo.imageHighSchoolFourChanged) {
          const storageRef = firebase.storage().ref();
          const fileName = "ImageHighSchoolFour";
          const uploadRef = storageRef
            .child("Athletes")
            .child("HighSchoolImages")
            .child(athleteId)
            .child("HighSchoolImages")
            .child(fileName);

          return uploadRef.put(athleteInfo.imageHighSchoolFour).on(
            "state_changed",
            (snapshot) => {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              dispatch({
                type: "UPDATE_ATHLETE_PROGRESS",
                value: progress,
                media: "Image HighSchool Schedule Four",
              });
            },
            (error) => {
              dispatch({ type: "UPDATE_ATHLETE_ERROR", error });
            },
            () => {
              uploadRef.getDownloadURL().then(function (downloadURL) {
                let athleteHighSchoolScheduleFour = {
                  imageHighSchoolFour: downloadURL,
                };

                const batch = firestore.batch();
                batch.set(athleteAdminImageRef, athleteHighSchoolScheduleFour, {
                  merge: true,
                });
                batch.set(athleteImageRef, athleteHighSchoolScheduleFour, {
                  merge: true,
                });

                batch
                  .commit()
                  .then(() => imageHighSchoolFiveChanged())
                  .catch((err) => {
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
                  });
              });
            }
          );
        } else {
          // HighSchool Schedule Four didn't change
          // check HighSchool Schedule Five
          imageHighSchoolFiveChanged();
        }
      }

      function imageHighSchoolFiveChanged() {
        if (athleteInfo.imageHighSchoolFiveChanged) {
          const storageRef = firebase.storage().ref();
          const fileName = "ImageHighSchoolFive";
          const uploadRef = storageRef
            .child("Athletes")
            .child("HighSchoolImages")
            .child(athleteId)
            .child("HighSchoolImages")
            .child(fileName);

          return uploadRef.put(athleteInfo.imageHighSchoolFive).on(
            "state_changed",
            (snapshot) => {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              dispatch({
                type: "UPDATE_ATHLETE_PROGRESS",
                value: progress,
                media: "Image HighSchool Schedule Five",
              });
            },
            (error) => dispatch({ type: "UPDATE_ATHLETE_ERROR", error }),
            () => {
              uploadRef.getDownloadURL().then(function (downloadURL) {
                let athleteHighSchoolScheduleFive = {
                  imageHighSchoolFive: downloadURL,
                };

                const batch = firestore.batch();
                batch.set(athleteAdminImageRef, athleteHighSchoolScheduleFive, {
                  merge: true,
                });
                batch.set(athleteImageRef, athleteHighSchoolScheduleFive, {
                  merge: true,
                });

                batch
                  .commit()
                  .then(() => imageActChanged())
                  .catch((err) =>
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err })
                  );
              });
            }
          );
        } else {
          imageActChanged();
        }
      }

      function imageActChanged() {
        if (athleteInfo.actScoreImageChanged) {
          const storageRef = firebase.storage().ref();
          const fileName = "ImageActScore";
          const uploadRef = storageRef
            .child("Athletes")
            .child("Images")
            .child(athleteId)
            .child("Images")
            .child(fileName);

          return uploadRef.put(athleteInfo.actScoreImage).on(
            "state_changed",
            (snapshot) => {
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              dispatch({
                type: "UPDATE_ATHLETE_PROGRESS",
                value: progress,
                media: "Image ACT Score",
              });
            },
            (error) => {
              dispatch({ type: "UPDATE_ATHLETE_ERROR", error });
            },
            () => {
              uploadRef.getDownloadURL().then(function (downloadURL) {
                var athleteImageAct = {
                  actScoreImage: downloadURL,
                };

                const batch = firestore.batch();
                batch.update(athleteAdminImageRef, athleteImageAct);
                batch.update(athleteImageRef, athleteImageAct);

                batch
                  .commit()
                  .then(() => videoOneChanged())
                  .catch((err) =>
                    dispatch({ type: "UPDATE_ATHLETE_ERROR", err })
                  );
              });
            }
          );
        } else {
          // image ACT did not change
          // check videoOne change
          videoOneChanged();
        }
      }

      function videoOneChanged() {
        if (athleteInfo.videoOneChanged) {
          // check if file or link

          if (athleteInfo.videoOneLink) {
            // it is a link

            var athleteVideoOne = {
              videoOne: athleteInfo.videoOneLink,
            };

            const batch = firestore.batch();
            batch.update(athleteAdminVideoRef, athleteVideoOne);
            batch.update(athleteVideoRef, athleteVideoOne);

            batch
              .commit()
              .then(() => videoTwoChanged())
              .catch((err) => dispatch({ type: "UPDATE_ATHLETE_ERROR", err }));
          } else {
            // it is a file

            const storageRef = firebase.storage().ref();
            const fileName = "VideoOne";
            const uploadRef = storageRef
              .child("Athletes")
              .child("Videos")
              .child(athleteId)
              .child("Videos")
              .child(fileName);

            return uploadRef.put(athleteInfo.videoOne).on(
              "state_changed",
              (snapshot) => {
                var progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                dispatch({
                  type: "UPDATE_ATHLETE_PROGRESS",
                  value: progress,
                  media: "Video One",
                });
              },
              (error) => {
                dispatch({ type: "UPDATE_ATHLETE_ERROR", error });
              },
              () => {
                uploadRef.getDownloadURL().then(function (downloadURL) {
                  var athleteVideoOne = {
                    videoOne: downloadURL,
                  };

                  const batch = firestore.batch();
                  batch.update(athleteAdminVideoRef, athleteVideoOne);
                  batch.update(athleteVideoRef, athleteVideoOne);

                  batch
                    .commit()
                    .then(() => {
                      videoTwoChanged();
                    })
                    .catch((err) => {
                      dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
                    });
                });
              }
            );
          }
        } else {
          // check videoTwo change
          videoTwoChanged();
        }
      }
      function videoTwoChanged() {
        if (athleteInfo.videoTwoChanged) {
          // check if file or link

          if (athleteInfo.videoTwoLink) {
            // it is a link

            var athleteVideoTwo = {
              videoTwo: athleteInfo.videoTwoLink,
            };

            const batch = firestore.batch();
            batch.update(athleteAdminVideoRef, athleteVideoTwo);
            batch.update(athleteVideoRef, athleteVideoTwo);

            batch
              .commit()
              .then(() => {
                videoThreeChanged();
              })
              .catch((err) => {
                dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
              });
          } else {
            // it is a file

            const storageRef = firebase.storage().ref();
            const fileName = "VideoTwo";
            const uploadRef = storageRef
              .child("Athletes")
              .child("Videos")
              .child(athleteId)
              .child("Videos")
              .child(fileName);

            return uploadRef.put(athleteInfo.videoTwo).on(
              "state_changed",
              (snapshot) => {
                var progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                dispatch({
                  type: "UPDATE_ATHLETE_PROGRESS",
                  value: progress,
                  media: "Video Two",
                });
              },
              (error) => {
                dispatch({ type: "UPDATE_ATHLETE_ERROR", error });
              },
              () => {
                uploadRef.getDownloadURL().then(function (downloadURL) {
                  var athleteVideoTwo = {
                    videoTwo: downloadURL,
                  };

                  const batch = firestore.batch();
                  batch.update(athleteAdminVideoRef, athleteVideoTwo);
                  batch.update(athleteVideoRef, athleteVideoTwo);

                  batch
                    .commit()
                    .then(() => {
                      videoThreeChanged();
                    })
                    .catch((err) => {
                      dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
                    });
                });
              }
            );
          }
        } else {
          // check videoThree change
          videoThreeChanged();
        }
      }
      function videoThreeChanged() {
        if (athleteInfo.videoThreeChanged) {
          // check if file or link

          if (athleteInfo.videoThreeLink) {
            // it is a link

            var athleteVideoThree = {
              videoThree: athleteInfo.videoThreeLink,
            };

            const batch = firestore.batch();
            batch.update(athleteAdminVideoRef, athleteVideoThree);
            batch.update(athleteVideoRef, athleteVideoThree);

            batch
              .commit()
              .then(() => videoFourChanged())
              .catch((err) => {
                dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
              });
          } else {
            // it is a file

            const storageRef = firebase.storage().ref();
            const fileName = "VideoThree";
            const uploadRef = storageRef
              .child("Athletes")
              .child("Videos")
              .child(athleteId)
              .child("Videos")
              .child(fileName);

            return uploadRef.put(athleteInfo.videoThree).on(
              "state_changed",
              (snapshot) => {
                var progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                dispatch({
                  type: "UPDATE_ATHLETE_PROGRESS",
                  value: progress,
                  media: "Video Three",
                });
              },
              (error) => {
                dispatch({ type: "UPDATE_ATHLETE_ERROR", error });
              },
              () => {
                uploadRef.getDownloadURL().then(function (downloadURL) {
                  var athleteVideoThree = {
                    videoThree: downloadURL,
                  };

                  const batch = firestore.batch();
                  batch.update(athleteAdminVideoRef, athleteVideoThree);
                  batch.update(athleteVideoRef, athleteVideoThree);

                  batch
                    .commit()
                    .then(() => {
                      videoFourChanged();
                    })
                    .catch((err) => {
                      dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
                    });
                });
              }
            );
          }
        } else {
          // check videoFour change
          videoFourChanged();
        }
      }
      function videoFourChanged() {
        if (athleteInfo.videoFourChanged) {
          // check if file or link

          if (athleteInfo.videoFourLink) {
            // it is a link

            var athleteVideoFour = {
              videoFour: athleteInfo.videoFourLink,
            };

            const batch = firestore.batch();
            batch.update(athleteAdminVideoRef, athleteVideoFour);
            batch.update(athleteVideoRef, athleteVideoFour);

            batch
              .commit()
              .then(() => {
                getNewData(athleteId);
                dispatch({ type: "UPDATE_ATHLETE_SUCCESS" });
              })
              .catch((err) => {
                dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
              });
          } else {
            // it is a file

            const storageRef = firebase.storage().ref();
            const fileName = "VideoFour";
            const uploadRef = storageRef
              .child("Athletes")
              .child("Videos")
              .child(athleteId)
              .child("Videos")
              .child(fileName);

            return uploadRef.put(athleteInfo.videoFour).on(
              "state_changed",
              (snapshot) => {
                var progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                dispatch({
                  type: "UPDATE_ATHLETE_PROGRESS",
                  value: progress,
                  media: "Video Four",
                });
              },
              (error) => {
                dispatch({ type: "UPDATE_ATHLETE_ERROR", error });
              },
              () => {
                uploadRef.getDownloadURL().then(function (downloadURL) {
                  var athleteVideoFour = {
                    videoFour: downloadURL,
                  };

                  const batch = firestore.batch();
                  batch.update(athleteAdminVideoRef, athleteVideoFour);
                  batch.update(athleteVideoRef, athleteVideoFour);

                  batch
                    .commit()
                    .then(() => {
                      getNewData(athleteId);
                      dispatch({ type: "UPDATE_ATHLETE_SUCCESS" });
                    })
                    .catch((err) => {
                      dispatch({ type: "UPDATE_ATHLETE_ERROR", err });
                    });
                });
              }
            );
          }
        } else {
          getNewData(athleteId);
          dispatch({ type: "UPDATE_ATHLETE_SUCCESS" });
        }
      }
    });
  };
};

export const deleteUpdateHistory = (id) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const documentRef = firestore.collection("updateReport").doc(id);
    documentRef.delete();
  };
};
